import axios from 'axios';
import config from '../config';

const GetAll = async (page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");

        const response = await axios.get(config.apiUrl + 'state/all?page=' + page + '&resultCount=' + count + '&keyword=' + keyword, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 200) {
            return {
                status: 200,
                states: response.data.states
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}

export { GetAll };